<template>
  <section class="height-100-p">
    <el-table
        ref="searchSummaryHolidayPeriodsTable"
        :data="holidayPeriods.list"
        v-loading="holidayPeriods.loadingSearch"
        id="holiday-periods-data-list"
        size="mini"
        tooltip-effect="dark"
        sortable
        class="dark-blue-table"
        :empty-text="$t('common.notAbleToFindRecords')"
        stripe
        @sort-change="handleSortChange"
    >
      <el-table-column
          prop="name"
          :label="$t('admin.holidayPeriods.name')"
          :min-width="10"
          sortable="custom"
          align="left"
          header-align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.name" placement="top">
            <span>{{ scope.row.name }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
          prop="earlyAccess"
          :label="$t('admin.holidayPeriods.earlyAccess')"
          :min-width="5"
          sortable="custom"
          align="center">
        <template slot-scope="scope">
          <i v-if="scope.row.earlyAccess" class="el-icon-success green-success"></i>
        </template>
      </el-table-column>
      <el-table-column
          prop="effectiveDate"
          :label="$t('admin.holidayPeriods.effectiveDate')"
          :min-width="7"
          sortable="custom"
          align="center">
        <template slot-scope="scope">
          {{ scope.row.effectiveDate | moment("MM/DD/YYYY") }}
        </template>
      </el-table-column>
      <el-table-column
          prop="expirationDate"
          :label="$t('admin.holidayPeriods.expirationDate')"
          :min-width="7"
          sortable="custom"
          align="center">
        <template slot-scope="scope">
          {{ scope.row.expirationDate | moment("MM/DD/YYYY") }}
        </template>
      </el-table-column>
      <el-table-column
          width="100"
          :label="$t('common.options')"
          align="center"
          fixed="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="$t('admin.holidayPeriods.details')" placement="top">
            <i @click="handleView(scope.row)" class="el-icon-search icon-action"> </i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('common.edit')" placement="top">
            <i @click="handleEdit(scope.row)" class="el-icon-edit icon-action"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('common.delete')"
                      placement="top">
            <i @click="handleDelete(scope.row)" class="el-icon-delete icon-action"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="holidayPeriods.actualFilters.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="holidayPeriods.actualFilters.rows"
        layout="total, sizes, prev, pager, next"
        :total="holidayPeriods.total"
        class="pagination-container">
    </el-pagination>
    <holiday-period-detail-dialog ref="holidayPeriodDetailDialog"/>
    <edit-holiday-period ref="editHolidayPeriod"/>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import EditHolidayPeriod from './components/EditHolidayPeriod';
import HolidayPeriodDetailDialog from './components/HolidayPeriodDetailDialog';

export default {
  name: 'SearchSummary',
  components: {
    EditHolidayPeriod,
    HolidayPeriodDetailDialog
  },
  computed: {
    ...mapState({
      holidayPeriods: state => state.holidayPeriods
    }),
    currentDate: () => new Date(new Date().setHours(0, 0, 0, 0))
  },
  methods: {
    handleSizeChange(val) {
      this.$store.dispatch('holidayPeriods/search', { rows: val, page: 1 });
    },
    handleCurrentChange(val) {
      this.$store.dispatch('holidayPeriods/search', { page: val });
    },
    handleSortChange({ prop, order }) {
      const orderDirection = order === 'ascending' ? 'asc' : 'desc';
      this.$store.dispatch('holidayPeriods/search', { orderField: prop, orderDirection });
    },
    handleView(row) {
      this.$store.dispatch('holidayPeriods/setRow', { row });
      this.$refs.holidayPeriodDetailDialog.showDialog();
    },
    handleEdit(row) {
      this.$store.dispatch('holidayPeriods/setRow', { row });
      this.$refs.editHolidayPeriod.showDialog();
    },
    async handleDelete(row) {
      const confirm = await this.$confirm(this.$t('admin.holidayPeriods.confirmDelete'),
        { confirmButtonText: this.$t('common.yes') }).catch(() => {});
      if (confirm) {
        Message.closeAll();
        const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
        try {
          await this.$store.dispatch('holidayPeriods/delete', row.id);
          this.$store.dispatch('holidayPeriods/search');
          loading.close();
          this.$message({
            type: 'success',
            message: this.$t('admin.holidayPeriods.deleteSuccess')
          });
        } finally {
          loading.close();
        }
      }
    }
  }
};
</script>
